import BaseRepository from './BaseRepository';

class LandlordLocationRepository extends BaseRepository {
    /**
     * Get all active locations created by current user.
     *
     * @param {Object} params
     * @returns {Promise}
     */
    getLocations(params = {}) {
        return super.get(this.route('account.space-owner.locations', params))
            .then(this.normaliseResponse);
    }
}

export default new LandlordLocationRepository();
